module.exports = __webpack_public_path__ + "img/app_code.d19d0c0b.png";